export default "__VITE_ASSET__NFnDgzr___"